import { LoadingOverlay } from '@mantine/core';

import { Declarant } from '@e-origin/shared';

import { AdditionalFiscalReferenceTable } from '@components';
import { useDeclarant, useUpdateDeclarant } from '@hooks/declarant';

interface PaymentsFormProps {
  editDisabled: boolean;
}

export const PaymentsForm: React.FC<PaymentsFormProps> = ({ editDisabled }) => {
  const { data: declarant, isLoading } = useDeclarant();
  const payments = declarant?.payments;
  const updateDeclarantMutation = useUpdateDeclarant();

  const handleUpdate = (updateData: Partial<Declarant>) => {
    updateDeclarantMutation.mutate({
      declarantId: declarant._id,
      declarant: updateData,
    });
  };

  if (!declarant) {
    return <LoadingOverlay visible={isLoading} overlayProps={{ radius: 'sm', blur: 2 }} />;
  }

  return (
    <AdditionalFiscalReferenceTable
      handleUpdate={handleUpdate}
      isCustomerFlow={false}
      payments={payments}
      titleOrder={4}
      groupProps={{ justify: 'space-between', align: 'center', mb: 'xl' }}
    />
  );
};
